import { render, staticRenderFns } from "./order-dialog.vue?vue&type=template&id=012b9c67&"
import script from "./order-dialog.vue?vue&type=script&lang=js&"
export * from "./order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./order-dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "order-dialog.vue"
export default component.exports